import React, { useRef } from 'react';

import styled, { css } from 'styled-components';

import { useAsset } from '~/techstyle-shared/react-assets';
import { Carousel, mobile, desktop } from '~/techstyle-shared/react-components';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';

import DiscoveryGuideFilterAssetCard from './DiscoveryGuideFilterAssetCard';

const StyledCarousel = styled(Carousel)`
  .flickity-slider img {
    max-width: none;
  }

  .flickity-button[disabled] {
    display: none;
  }

  .flickity-enabled:focus {
    outline: none;
  }

  .flickity-button:focus {
    outline: none;
    box-shadow: none;
  }

  ${desktop`
    .flickity-prev-next-button {
      &.previous {
        left: -25px;
      }

      &.next {
        right: -25px;
      }
    }
  `}

  ${mobile`
  .flickity-prev-next-button {
     width: 30px;
     height: 30px;
  }
`}
`;

const cellStyle = css`
  counter-increment: carousel-cell;
  width: max-content;
  margin-right: 8px;
`;

const CarouselContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  margin-top: 24px;
`;

// Note: The mobile grid version does not have the lead marketing asset, whereas the desktop version does.
// The mobile version also does not have the pill under the carousel. It's moved to below the grid header
const MobileGridDiscoveryGuide = () => {
  const { gridStyleGuide } = useBuilderConstructorGridInputs();

  const assetContainerName =
    gridStyleGuide?.assetContainers?.mobile ||
    gridStyleGuide?.assetContainers?.desktop;
  const mobileAssetContainer = useAsset(assetContainerName, {
    multi: true,
  });

  const mobileAssets = mobileAssetContainer?.data?.assets || [];

  // flickity carousel dependencies
  const flickityRef = useRef();
  const carouselOptions = {
    contain: true,
    pageDots: false,
    resize: true,
    groupCells: true,
    cellStyle,
    freeScroll: true,
    wrapAround: false,
    autoPlay: false,
  };

  if (!gridStyleGuide || !mobileAssets.length) {
    return null;
  }

  return (
    <CarouselContainer>
      <StyledCarousel {...carouselOptions} flickityRef={flickityRef}>
        {mobileAssets.map((asset) => (
          <DiscoveryGuideFilterAssetCard
            key={asset.id}
            {...asset}
            onLoad={() => {
              if (flickityRef?.current) {
                flickityRef.current.resize();
              }
            }}
          />
        ))}
      </StyledCarousel>
    </CarouselContainer>
  );
};

export default MobileGridDiscoveryGuide;
